import GnlMesajCountResponse from "src/models/Genel/GnlMesajCountResponse";
import GnlMesajDTO from "src/models/Genel/GnlMesajDTO";
import { GnlMesajRequest } from "src/models/Genel/GnlMesajRequest";
import api from "../core/api";

const duyurularController = 'Duyurular/'

export const GnlMesajApi = api.injectEndpoints({
    endpoints: builder => ({
        getMesaj: builder.query<Array<GnlMesajDTO>, GnlMesajRequest>({
            query: (request) => {
                return {
                    url: duyurularController + "GnlMesajGetir",
                    method: "POST",
                    body: JSON.stringify(request)
                }
            },
            keepUnusedDataFor: 0,
            providesTags: ['GnlMesaj']
        }),
        getMesajById: builder.query<GnlMesajDTO, number>({
            query: (request) => {
                return {
                    url: duyurularController + "GnlMesajGetirById",
                    method: "GET",
                    params: { id: request }
                }
            },
            keepUnusedDataFor: 0,
            providesTags: ['GnlMesaj']
        }),
        createMesaj: builder.mutation<GnlMesajDTO, GnlMesajDTO>({
            query(request) {
                return {
                    url: duyurularController + "MesajEkle",
                    method: 'POST',
                    body: JSON.stringify(request)
                };
            },
            invalidatesTags: ['GnlMesaj']
        }),
        updateMesaj: builder.mutation<GnlMesajDTO, GnlMesajDTO>({
            query(request) {
                return {
                    url: duyurularController + "MesajGuncelle",
                    method: 'PUT',
                    body: JSON.stringify(request)
                };
            },
            invalidatesTags: ['GnlMesaj'],
        }),
        deleteMesaj: builder.mutation<boolean, GnlMesajDTO>({
            query(request) {
                return {
                    url: duyurularController + "MesajSil",
                    method: 'DELETE',
                    body: request
                };
            },
            invalidatesTags: ['GnlMesaj']
        }),

        // ok
        numberOfDuyurularGetir: builder.query<GnlMesajCountResponse, GnlMesajRequest>({
            query(request) {
                return {
                    url: duyurularController + "DuyurularSayiGetir",
                    method: 'POST',
                    body: JSON.stringify(request)
                };
            },
            providesTags: ['GnlMesaj']
        })
    })
})

// unwrap
export const {
    useNumberOfDuyurularGetirQuery,
    useDeleteMesajMutation,
    useUpdateMesajMutation,
    useCreateMesajMutation,
    useGetMesajQuery,
    useGetMesajByIdQuery,
    useLazyGetMesajByIdQuery
} = GnlMesajApi;

